// extracted by mini-css-extract-plugin
export var selectContainer = "RegionSelector-module--select-container--30d4c";